export default function StudioAuthoringCoursesController() {}
